/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Full_Glad_Lion_TalkInputs */

const en_full_glad_lion_talk = /** @type {(inputs: Full_Glad_Lion_TalkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage the user's survey settings`)
};

const de_full_glad_lion_talk = /** @type {(inputs: Full_Glad_Lion_TalkInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verwalten Sie die Umfrage-Einstellungen des Benutzers`)
};

/**
* | output |
* | --- |
* | "Manage the user's survey settings" |
*
* @param {Full_Glad_Lion_TalkInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const full_glad_lion_talk = /** @type {((inputs?: Full_Glad_Lion_TalkInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Full_Glad_Lion_TalkInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_full_glad_lion_talk(inputs)
	return de_full_glad_lion_talk(inputs)
});